import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { StorageService } from '../../services/storage.service';

/**
 * Clears session and returns to login on 401 (AIO-frontend pattern, simplified).
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const storage = inject(StorageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        storage.clear();
        void router.navigate(['/login'], { replaceUrl: true });
      }
      return throwError(() => error);
    })
  );
};
